import { useState, useEffect, useCallback } from 'react';
import { isFavorite, toggleFavorite } from '../../utils/favorites';

/**
 * Reusable favorite toggle (filled star = favorited).
 * `item` must have at least { id, type, name }. Extra fields (sport, meta,
 * matchId, href) are stored verbatim and used by the Favoris page.
 */
export default function FavStar({ item, size = 16, className }) {
  const [on, setOn] = useState(() => isFavorite(item.id, item.type));

  useEffect(() => {
    const sync = () => setOn(isFavorite(item.id, item.type));
    sync();
    window.addEventListener('favoritesChanged', sync);
    return () => window.removeEventListener('favoritesChanged', sync);
  }, [item.id, item.type]);

  const onClick = useCallback((e) => {
    e.stopPropagation();
    e.preventDefault();
    toggleFavorite(item);
  }, [item]);

  return (
    <button
      type="button"
      className={'favstar' + (on ? ' is-on' : '') + (className ? ' ' + className : '')}
      onClick={onClick}
      aria-label="favorite"
      aria-pressed={on}
      style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', display: 'grid', placeItems: 'center', flex: 'none', lineHeight: 0 }}
    >
      <svg width={size} height={size} viewBox="0 0 24 24"
        fill={on ? '#f6c344' : 'none'}
        stroke={on ? '#f6c344' : '#757490'}
        strokeWidth="1.7" strokeLinejoin="round">
        <path d="M12 2.6l2.9 5.88 6.49.94-4.7 4.58 1.11 6.46L12 17.9l-5.8 3.05 1.1-6.46-4.69-4.58 6.49-.94z" />
      </svg>
    </button>
  );
}
